import { createColumnHelper } from '@tanstack/react-table';
import { IRoleCard } from '@westondev/tableturn-core';

export interface IRoleCardTable extends IRoleCard {
  //TODO this type could be part of the state
  payBasis: string;
  defaultPay: number;
  overridePay: number;
  canDelete: boolean;
}
export const columnHelper = createColumnHelper<IRoleCardTable>();

export const ROW_ID_PREFIX = 'role-pay-basis-row';
